import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
const boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Box/boxClasses.js
// module id = 429
// module chunks = 22